const findError = (error, error_message = "") => {
  let message;
  switch (error) {
    case "NotAuthorizedException":
      message = error_message ? error_message : "Incorrect username or password.";
      break;

    case "UserNotConfirmedException":
      message = "User is not confirmed";
      break;

    case "CodeMismatchException":
      message = "Invalid verification code provided, please try again.";
      break;

    case "UsernameExistsException":
      message = "An account with the given email already exists";
      break;

    case "LimitExceededException":
      message = "Attempt limit exceeded, please try after some time.";
      break;

    case "UserNotFoundException":
      message = "Entered email address is not registered with us.";
      break;

    case "InvalidParameterException":
      message = "Entered email address is not registered with us.";
      break;

    default:
      message = "Something went wrong. Please try after some time.";
  }
  return message;
};

export default findError;
